import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';

interface PageSectionProps {
  sectionId?: string;
  children?: ReactNode;
}

const PageSection: FC<PageSectionProps> = ({ sectionId, children }) => {
  let containerClass = 'o-page-section__content-container';
  // TODO , how to represetnt this
  containerClass += ' o-page-section__content-container--full-width';
  containerClass += ' o-page-section__content-container--no-padding-left';

  return (
    <div className="o-page-section l-mt-sm l-pt-none" id={sectionId}>
      <div className={containerClass + ' l-pt-none l-mt-neg-sm'}>
        {children}
      </div>
    </div>
  );
};

PageSection.propTypes = {
  sectionId: PropTypes.string,
  children: PropTypes.node,
};

PageSection.defaultProps = {
};

export default PageSection;
